<div class="form-group searching" [ngClass]="{ 'has-error': error, searching: searching }">
    <input
        [type]="type"
        class="form-control"
        placeholder="{{ placeholder | translate }}"
        [disabled]="disable"
        [readonly]="readonly"
        [(ngModel)]="value"
        container="body"
        [popover]
        [adaptivePosition]="false"
        containerClass="error popover-compact"
        triggers="mouseenter:mouseleave"
        (keyup)="onChange($event)"
    />
    @if (searching) {
        <span class="spinner spinner-sm"></span>
    }
</div>
